module.exports = __webpack_public_path__ + "static/OlricA-9e1d20c5fae48b369e4e15bfdc45ccc8.gif";